export default __webpack_public_path__ + "static/media/typescript.a2cdefcf.svg";